export function removeModalBackground() {
    let modalBackdrops = document.getElementsByClassName("modal-backdrop");
    if (modalBackdrops.length > 0) {
        modalBackdrops[0].remove();
    }
}